// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/6aab5d3e6257625c9f61.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"72b6caf3857e3f348ef1","267":"d16181de73dbbcf7e587","268":"54e5323335bbd83e3bac"}[chunkId] + ".chunk.js";
};